import type { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import type { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';

import { isDeleted } from './isDeleted';

export const findDCCTVolumeFile = (assets: Asset[], report: Report) => {
  const volumeAsset = assets.find((asset) => {
    if (isDeleted(asset) || asset.Kind.case !== 'Study') {
      return false;
    }

    const study = asset.Kind.value;

    return (
      report.SourceStudyIDs.includes(study.StudyID) &&
      study.PatientID === report.PatientID &&
      study.OrganizationID === report.OrganizationID &&
      study.Content.case === 'CBCTDCCT'
    );
  });

  if (
    volumeAsset?.Kind.case !== 'Study' ||
    volumeAsset.Kind.value.Content.case !== 'CBCTDCCT'
  ) {
    return null;
  }

  return volumeAsset.Kind.value.Content.value.Volume ?? null;
};

export const findDCCTVolumeFileID = (assets: Asset[], report: Report) =>
  findDCCTVolumeFile(assets, report)?.ID || null;
